<template>
<v-snackbar v-model="this.$store.state.alert.show" bottom :color="this.$store.state.alert.color" :timeout="-1" dark>
    <span class="mb-3 py-3 d-block">{{ this.$store.state.alert.msg }}</span>
    <v-btn block depressed outlined color="secondary" @click="closeAlert">
        Cerrar
    </v-btn>
</v-snackbar>
</template>

<script>
export default {
    name: 'Alert',
    methods: {
        closeAlert() {
            this.$store.dispatch("setAlert", {
                show: false,
                msg: null,
                color: 'error'
            });
        }
    }
}
</script>
